module.exports = __webpack_public_path__ + "img/LMS.f89486ef.svg";